<template>
  <div class="full-page" :key="storeCode">
    <template v-if="this.$route.name == 'store'">
      Loading Store...
    </template>
    <template v-else>
      <router-view></router-view>
    </template>
  </div>
</template>
<script>
import { getSavedState } from "@/helpers/LocalStorage.js";

export default {
  name: "storeWrapper",
  beforeMount() {
    if (this.$route.name == "store") {
      // Get store and department from Vuex or localStorage
      let storeCode = this.$store.getters["general/getActiveStore"]?.code;
      let departmentCode = this.$store.getters["general/getActiveDepartment"]
        ?.code;

      // If not in Vuex, try to get from localStorage
      if (!storeCode) {
        storeCode = getSavedState("store.selectedStore");
      }
      if (!departmentCode) {
        departmentCode = getSavedState("store.selectedDepartment");
      }

      // Default to "all" if still no department
      if (!departmentCode) {
        departmentCode = "all";
      }

      // Redirect to dashboard with the store and department
      if (storeCode && departmentCode) {
        this.$router.replace({
          name: "DashboardPage",
          params: {
            storeCode: storeCode,
            departmentCode: departmentCode
          }
        });
      }
    }
  },
  computed: {
    storeCode() {
      return this.$store.getters["general/getActiveStore"]?.code;
    },
    departmentCode() {
      return this.$store.getters["general/getActiveDepartment"]?.code;
    }
  }
};
</script>

<style lang="scss">
// .full-page {
//   // height: 100%;
// }
</style>
